import { render, staticRenderFns } from "./firmakopyala.vue?vue&type=template&id=3daffb5b&"
import script from "./firmakopyala.vue?vue&type=script&lang=js&"
export * from "./firmakopyala.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports